// Two-level sub-navigation for the Courses page
// Top bar (dark navy) — main sections
// Bottom bar (light) — subtopics of the active section

export default function CoursesSubNav({ subNav, secondaryNav, activeSection, activeSub }) {
  const currentSecondary = secondaryNav[activeSection] || null;

  return (
    <>
      {/* Main sub-nav (dark, navy) — fixed below header */}
      <div className="fixed top-[112px] left-0 right-0 z-40 bg-[#0A1628] border-b border-[#1A2D4A]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center gap-6 md:gap-8 h-14 overflow-x-auto">
          {subNav.map((item) => {
            const uniqueKey = item.key || item.id;
            const isActive = activeSection === item.id;
            return (
              <a
                key={uniqueKey}
                href={`#${item.id}`}
                className={`relative text-[13px] font-semibold uppercase tracking-wider transition-all duration-300 py-3 whitespace-nowrap inline-flex items-center gap-1.5 ${
                  item.glow
                    ? "text-[#F59E0B] animate-pulse-glow"
                    : isActive
                    ? "text-white"
                    : "text-slate-500 hover:text-slate-300"
                }`}
                data-testid={`courses-sub-${uniqueKey}`}
              >
                {item.glow && <span className="text-base">🚀</span>}
                {item.label}
                {isActive && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#00A8FF] to-[#F59E0B] rounded-full" />
                )}
              </a>
            );
          })}
        </div>
      </div>

      {/* Secondary sub-nav (light, white) — only when current section has subtopics */}
      {currentSecondary && (
        <div className="fixed top-[168px] left-0 right-0 z-30 bg-gradient-to-b from-white to-slate-50 border-b border-slate-200 shadow-md">
          <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center gap-2 md:gap-3 h-14 overflow-x-auto">
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400 mr-2 hidden md:flex items-center gap-1.5 shrink-0">
              <span className="w-6 h-px bg-slate-300" />
              Tópicos
            </span>
            {currentSecondary.map((item) => {
              const isActiveSub = activeSub === item.id;
              return (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  className={`group inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider whitespace-nowrap px-3.5 py-2 rounded-lg transition-all duration-300 border ${
                    isActiveSub
                      ? "text-white border-transparent shadow-md"
                      : "text-slate-600 hover:text-[#0A1628] border-slate-200 bg-white hover:shadow-sm hover:-translate-y-0.5"
                  }`}
                  style={
                    isActiveSub
                      ? { backgroundColor: item.color, borderColor: item.color, boxShadow: `0 4px 12px ${item.color}40` }
                      : {}
                  }
                  data-testid={`courses-sec-${item.id}`}
                >
                  <span
                    className={`w-1.5 h-1.5 rounded-full transition-all ${isActiveSub ? "bg-white" : ""}`}
                    style={!isActiveSub ? { backgroundColor: item.color } : {}}
                  />
                  {item.label}
                </a>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
